import type { PlacedTile, ReplayMove } from "../../shared/types";

export const PLAYBACK_DURATION_MS = 30000;

export function getBoardAtTime(moves: ReplayMove[], timeMs: number): PlacedTile[] {
  const boardMap = new Map<string, PlacedTile>();
  for (const move of moves) {
    if (move.t > timeMs) break;
    if (move.a === "place" && move.x !== undefined && move.y !== undefined) {
      const key = `${move.x},${move.y}`;
      boardMap.set(key, {
        tileId: move.tileId || "",
        letter: move.letter || "",
        x: move.x,
        y: move.y,
      });
    } else if (move.a === "recall" && move.tileId) {
      for (const [key, tile] of boardMap) {
        if (tile.tileId === move.tileId) {
          boardMap.delete(key);
          break;
        }
      }
    }
  }
  return Array.from(boardMap.values());
}

export function hasSubmitted(moves: ReplayMove[], timeMs: number): boolean {
  return moves.some((m) => m.a === "submit" && m.t <= timeMs);
}

export function formatDuration(ms: number): string {
  const totalSec = Math.round(ms / 1000);
  const m = Math.floor(totalSec / 60);
  const s = totalSec % 60;
  return `${m}:${s.toString().padStart(2, "0")}`;
}